import React, {useContext, useRef} from "react";
import Headroom from "react-headroom";
import {Link} from "react-router-dom";
import "./Header.scss";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import StyleContext from "../../contexts/StyleContext";
import {useSettings} from "../../contexts/SettingsContext";
import {greeting} from "@features/portfolio/config";
import {trackPageView} from "@shared/lib/analytics";

function Header() {
  const {isDark} = useContext(StyleContext);
  const {isVisible} = useSettings();
  const menuToggle = useRef(null);

  const closeMenu = () => {
    if (menuToggle.current) menuToggle.current.checked = false;
  };

  // Task 1 "who clicked the contact button" — this nav link is the one
  // persistent Contact CTA present on every page, so it's the canonical
  // place to log the click. Fire-and-forget, same as every other
  // trackPageView() call — never blocks the navigation it's attached to.
  const trackContactClick = () => {
    closeMenu();
    trackPageView(window.location.pathname, "contact_click");
  };

  return (
    <Headroom>
      <header className={isDark ? "dark-menu header" : "header"}>
        <Link to="/" className="logo" onClick={closeMenu}>
          <span className="grey-color"> &lt;</span>
          <span className="logo-name">{greeting.username}</span>
          <span className="grey-color">/&gt;</span>
        </Link>
        <input ref={menuToggle} className="menu-btn" type="checkbox" id="menu-btn" />
        <label className="menu-icon" htmlFor="menu-btn">
          <span className={isDark ? "navicon navicon-dark" : "navicon"}></span>
        </label>
        <ul className={isDark ? "dark-menu menu" : "menu"}>
          <li><Link to="/" onClick={closeMenu}>Blog</Link></li>
          <li><Link to="/portfolio" onClick={closeMenu}>Portfolio</Link></li>
          {isVisible("sections.skills") && (
            <li><Link to="/portfolio#skills" onClick={closeMenu}>Skills</Link></li>
          )}
          {isVisible("sections.experience") && (
            <li><Link to="/portfolio#experience" onClick={closeMenu}>Experience</Link></li>
          )}
          {isVisible("sections.resume") && (
            <li>
              <Link to="/resume" onClick={closeMenu}>Resume</Link>
            </li>
          )}
          {isVisible("sections.projects") && (
            <li><Link to="/portfolio#projects" onClick={closeMenu}>Projects</Link></li>
          )}
          {isVisible("sections.contact") && (
            <li><Link to="/portfolio#contact" onClick={trackContactClick}>Contact</Link></li>
          )}
          <li className="header__theme">
            <ToggleSwitch />
          </li>
        </ul>
      </header>
    </Headroom>
  );
}

export default Header;
